import {
    DealerCampaignCashOfferFootnoteType,
    DealerCampaignFinanceOfferFootnoteType,
    DealerCampaignLeaserOfferFootnoteType,
} from '../interfaces/dealer-campaigns';
import { walkStrings } from './walk-strings';

export function getDealerCampaignLeaserOfferHeadline(footnoteType: DealerCampaignLeaserOfferFootnoteType): string {
    if (footnoteType === DealerCampaignLeaserOfferFootnoteType.PK_1) {
        return 'Ihr Hyundai Kilometer Leasing';
    }
    return 'Ein unverbindliches Leasingbeispiel';
}

export function getDealerCampaignFinanceOfferHeadline(footnoteType: DealerCampaignFinanceOfferFootnoteType): string {
    if (footnoteType === DealerCampaignFinanceOfferFootnoteType.PK_1_H) {
        return 'Hyundai Ziel-Finanzierung';
    }
    return 'Hyundai Ziel-Finanzierung';
}

export function getFootnoteForDealerCampaignLeasingOffer(offer: {
    footnoteType: DealerCampaignLeaserOfferFootnoteType;
    transferAndRegistrationPrice: string;
    validUntil: string;
    specificModel: string;
}): string {
    const transferAndRegistrationPrice = formatPrice(offer.transferAndRegistrationPrice);
    if (offer.footnoteType === DealerCampaignLeaserOfferFootnoteType.PK_1) {
        return `Unverbindliche Leasingbeispiele der HYUNDAI Finance, ein Geschäftsbereich der Hyundai Capital Bank Europe GmbH, Europa-Allee 22, 60327 Frankfurt am Main. Verbraucher haben ein gesetzliches Widerrufsrecht. Verpflichtung zum Abschluss einer Vollkaskoversicherung. Kostenpflichtige Zusatzausstattung möglich. Überführungs- und Zulassungskosten in Höhe von ${transferAndRegistrationPrice} EUR für den ${offer.specificModel} werden bei Lieferung des Fahrzeugs separat in Ansatz gebracht. Alle Preise inkl. gesetzlicher MwSt. Angebot gültig bis ${offer.validUntil}`;
    }

    if (offer.footnoteType === DealerCampaignLeaserOfferFootnoteType.GK_2) {
        return `Ein unverbindliches Leasingbeispiel für Gewerbekunden der HYUNDAI Finance, ein Geschäftsbereich der Hyundai Capital Bank Europe GmbH, Europa-Allee 22, 60327 Frankfurt am Main. Kostenpflichtige Zusatzausstattung möglich. Überführungs- und Zulassungskosten in Höhe von ${transferAndRegistrationPrice} EUR für den ${offer.specificModel} werden bei Lieferung des Fahrzeugs separat in Ansatz gebracht. Alle Preise inkl. gesetzlicher MwSt. Angebot gültig bis ${offer.validUntil}.`;
    }
    return '';
}

export function getFootnoteForDealerCampaignCashPriceOffer(offer: {
    footnoteType: DealerCampaignCashOfferFootnoteType;
    transferAndRegistrationPrice: string;
    validUntil: string;
    specificModel: string;
}): string {
    const transferAndRegistrationPrice = formatPrice(offer.transferAndRegistrationPrice);
    if (offer.footnoteType === DealerCampaignCashOfferFootnoteType.PK_1) {
        return `Überführungskosten in Höhe von ${transferAndRegistrationPrice} EUR enthalten. Angebot gültig bis ${offer.validUntil}.`;
    }
    /*
    if (offer.footnoteType === DealerCampaignCashOfferFootnoteType.GK_2) {
        return `Überführungskosten in Höhe von ${transferAndRegistrationPrice} EUR enthalten. Angebot gültig bis ${offer.validUntil}.`;
    }
*/
    return '';
}

export function getFootnoteForDealerCampaignFinanceOffer(offer: {
    footnoteType: DealerCampaignFinanceOfferFootnoteType;
    transferAndRegistrationPrice: string;
    validUntil: string;
    specificModel: string;
}): string {
    const transferAndRegistrationPrice = formatPrice(offer.transferAndRegistrationPrice);
    if (offer.footnoteType === DealerCampaignFinanceOfferFootnoteType.PK_1_H) {
        return `
        Ein unverbindliches Finanzierungsbeispiel der HYUNDAI Finance, ein Geschäftsbereich der Hyundai Capital Bank Europe GmbH, Europa-Allee 22, 60327 Frankfurt am Main. Verbraucher haben ein gesetzliches Widerrufsrecht. Verpflichtung zum Abschluss einer Teilkaskoversicherung. Kostenpflichtige Zusatzausstattung möglich. Überführungs- und Zulassungskosten in Höhe von ${transferAndRegistrationPrice} EUR werden bei Lieferung des Fahrzeugs separat in Ansatz gebracht. Alle Preise inkl. gesetzlicher MwSt. Angebot gültig bis ${offer.validUntil}.`;
    }
    return '';
}

export const DealerCampaignFootnotes = {
    ID_PREFIX: 'dealerCampaign_',

    getFootnoteId(campaignId: number, id: string): string {
        return `${DealerCampaignFootnotes.ID_PREFIX}${campaignId}_${id}`;
    },

    replaceFootnotes<T = unknown>(campaignId: number, data: T): T {
        return walkStrings(data, (value) => {
            return value.replaceAll(
                /#(\d+)#/g,
                (_match, id) => `#f_${DealerCampaignFootnotes.getFootnoteId(campaignId, id)}#`,
            );
        });
    },
};

export const formatPrice = (price: string): string => {
    const normalizedPrice = price.replace(',', '.');
    const numericValue = Number(normalizedPrice);
    return new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(numericValue);
};

export const formatStringNumberToLocale = (str: string, digits = 2): string => {
    const float = Number.parseFloat(str.toString().replace('.', '').replace(',', '.'));
    return Number.isNaN(float)
        ? str
        : float.toLocaleString('de-DE', { minimumFractionDigits: digits, maximumFractionDigits: digits });
};
